import dayjs, {Dayjs} from "dayjs";
import TransactionDirectionEnum from "../enums/TransactionDirectionEnum";
import TransactionReferralEnum from "../enums/TransactionReferralEnum";

export default class Transaction {
    public id: string
    public amount: number
    public balanceBefore: number
    public balanceAfter: number
    public direction: TransactionDirectionEnum
    public receivedAt: string
    public reason: string
    public receipt: string
    public referral: TransactionReferralEnum
    public referralName: string
    public externalReference: string
    public communityName: string
    public createdAt: Dayjs
    public updatedAt: Dayjs

    constructor(data: any) {
        this.id = data.reference
        this.amount = data.amount
        this.balanceBefore = data.balanceBefore
        this.balanceAfter = data.balanceAfter
        this.direction = TransactionDirectionEnum.tryParse(data.direction)
        this.receivedAt = data.receivedAt
        this.reason = data.reason
        this.referral = TransactionReferralEnum.tryParse(data.referral)
        this.receipt = data.receipt
        this.referralName = data.referralName
        this.communityName = data.communityName
        this.externalReference = data.externalReference
        this.createdAt = dayjs(data.createdAt)
        this.updatedAt = dayjs(data.updatedAt)
    }
}
